module.exports = __webpack_public_path__ + "img/ShantyTown.5563f040.jpg";